import React from "react";

import "./stylesPromoNotificationPreview.css";

import ProfitBoostImage from "../../../../../../assets/images/profit-boost.png";
import PurchaseMatchImage from "../../../../../../assets/images/pruchase-match.png";
import FreebetsImage from "../../../../../../assets/images/free-bets.png";

import { ClockCircleOutlined } from "@ant-design/icons";
import { AppStrings } from "../../../../../../utils/constants/AppStrings";

const getPromoPreview = () => ({
  free_bets: {
    title: "20 Free Bet Cash Await Your Victory!",
    description:
      "Your luck brings in coins – now it's time to place a free bet and win even more!",
    image: FreebetsImage,
  },
  profit_boost: {
    title: "Profit Boost! 20% Extra",
    description: "Maximize Your Winnings with Profit Boost!",
    image: ProfitBoostImage,
  },
  purchase_match: {
    title: "Pay 1 - get x2",
    description:
      "Get +100% on your Rebet Coins Bundle! Unlock Savings on Rebet Cash Purchase!",
    image: PurchaseMatchImage,
  },
});

function PromoNotificationPreview({ activePromoVariant }) {
  const promoPreview = getPromoPreview();
  const preview = promoPreview[activePromoVariant] ?? promoPreview.purchase_match;

  return (
    <div className="promo-notification-preview-container">
      <div className="promo-notification-preview-header">
        <h2>{AppStrings.PAM_NEW_PROMOTION_PROMO_PREVIEW}</h2>
      </div>
      <div className="promo-notification-preview-content">
        <div className="promo-notification-title">
          <img src={preview.image} alt="promo" />
          <span className="time-left">
            <ClockCircleOutlined className="clock-icon" />
            2d 1h left
          </span>
          <h1>{preview.title}</h1>
          <p>{preview.description}</p>
        </div>
        <section className="terms-of-use">
          <h3>{AppStrings.TERMS_OF_USE}</h3>

          <h2>1. Participation Period:</h2>
          <p>
            The promotion is applicable for any eligible transactions made
            between February 10th, 00:00 GMT, and February 28th, 23:59 GMT.
          </p>

          <h2>2. Eligibility Window:</h2>
          <p>
            To qualify for the promotion, your transaction must be initiated
            within the specified timeframe. Any transactions initiated before or
            after this period will not be eligible.
          </p>

          <h2>3. Redemption Deadline:</h2>
          <p>
            Ensure that any benefits, bonuses, or rewards earned during this
            promotion are redeemed by{" "}
            <strong>[Insert Redemption Deadline]</strong>. After this date,
            unclaimed rewards may expire.
          </p>

          <h2>4. Terms and Conditions:</h2>
          <p>
            Ensure that any benefits, bonuses, or rewards earned during this
            promotion are redeemed by{" "}
            <strong>[Insert Redemption Deadline]</strong>. After this date,
            unclaimed rewards may expire.
          </p>

          <h2>5. Not Applicable Beyond Expiry:</h2>
          <p>
            Any attempts to participate in or benefit from the promotion after
            the specified expiry date will be considered invalid.
          </p>

          <h2>6. Timezone Consideration:</h2>
          <p>
            All times mentioned are in GMT (Greenwich Mean Time). Please adjust
            for your local timezone accordingly.
          </p>
        </section>
      </div>
      <div className="promo-notification-preview-footer">
        <button className="send-button">Go to Wallet</button>
      </div>
    </div>
  );
}

export default PromoNotificationPreview;
